module.exports = __webpack_public_path__ + "3276ba2c9765eb8c5364fce807827250.fbx";